import React, { useEffect, useState } from 'react'
import ContainerDashboard from '../../components/layouts/ContainerDashboard'
import { useNavigate, useParams } from 'react-router-dom';
import config, { axiosInstance } from '../Config';
import Loader from '../Loader';
import { toast } from 'react-toastify';

const EditStaff = () => {

    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [gender, setGender] = useState('')
    const [role, setRole] = useState('')
    const [roleOptions, setRoleOptions] = useState([])
    const [password, setPassword] = useState('')
    const [showPassword, setShowPassword] = useState(false)
    const [loading, setLoading] = useState(false)
    const [errors, setErrors] = useState({})

    const navigate = useNavigate()
    const { userKey } = useParams()

    useEffect(() => {
        window.scrollTo(0, 0)
        document.title = "Edit Staff | Mindora"
        loadData()
    }, [])

    const loadData = async () => {
        setLoading(true)
        try {
            const [rolesRes, staffRes] = await Promise.all([
                axiosInstance.get('roles'),
                axiosInstance.get(`staff/${userKey}`)
            ])

            setRoleOptions(rolesRes.data?.data ?? rolesRes.data ?? [])

            const staff = staffRes.data?.data ?? staffRes.data
            setName(staff.name ?? '')
            setEmail(staff.email ?? '')
            setPhone(staff.phone ?? '')
            setGender(staff.gender ?? '')
            setRole(staff.role ?? '')
        } catch {
            toast.error('Failed to load staff data.')
        } finally {
            setLoading(false)
        }
    }

    const validateForm = () => {
        const newErrors = {}

        if (!name) newErrors.name = 'Name is required'

        if (!email) newErrors.email = 'Email is required'
        else if (!/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/.test(email)) newErrors.email = 'Invalid email format'

        if (!phone) newErrors.phone = 'Phone Number is required'
        else if (phone.length !== 10) newErrors.phone = 'Phone Number must be exactly 10 digits'

        if (!gender) newErrors.gender = 'Gender is required'
        if (!role) newErrors.role = 'Role is required'

        setErrors(newErrors)
        return Object.keys(newErrors).length === 0
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!validateForm()) return

        setLoading(true)
        try {
            const body = { name, email, phone, gender, role }
            if (password) body.password = password

            const res = await axiosInstance.put(`staff/${userKey}`, body)

            if (res.data.success === false) {
                toast.error(res.data.message || 'Something went wrong!')
                return
            }

            toast.success('Staff Updated Successfully!')
            setTimeout(() => navigate(`${config.appUrl}staff`), 1500)
        } catch (err) {
            toast.error(err?.response?.data?.message || 'Something went wrong!')
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            {loading && <Loader />}
            <ContainerDashboard title="Edit Staff" description="Everything here">
                <div className="p-4 py-5 bg-gradientt rounded-4">
                    <section className="ps-dashboards" id="homepages">
                        <div className="row justify-content-between align-items-center">
                            <div>
                                <form onSubmit={handleSubmit} className="therapist-profile-form">
                                    <div className="row px-md-5">

                                        <div className="col-md-6 px-4">
                                            <div className="input-field">
                                                <label htmlFor="role" className='label'>
                                                    <select id="role" value={role} onChange={(e) => setRole(e.target.value)}>
                                                        <option value="">Select Role</option>
                                                        {roleOptions?.map((r) => (
                                                            <option key={r.id} value={r.roleName}>{r.roleName}</option>
                                                        ))}
                                                    </select>
                                                    <span>Role <i className='text-danger'>*</i></span>
                                                </label>
                                            </div>
                                            {errors.role && <span className='badge text-danger span-error'>{errors.role}</span>}
                                        </div>

                                        <div className="col-md-6 px-4">
                                            <div className="input-field">
                                                <label htmlFor="name" className='label'>
                                                    <input type="text" id="name" placeholder="Name"
                                                        value={name}
                                                        onKeyPress={(e) => { if (/[0-9]/.test(e.key)) e.preventDefault() }}
                                                        onChange={(e) => setName(e.target.value)}
                                                    />
                                                    <span>Full Name <i className='text-danger'>*</i></span>
                                                </label>
                                            </div>
                                            {errors.name && <span className='badge text-danger span-error'>{errors.name}</span>}
                                        </div>

                                        

                                        <div className="col-md-6 px-4">
                                            <div className="input-field">
                                                <label htmlFor="gender" className='label'>
                                                    <select id="gender" value={gender} onChange={(e) => setGender(e.target.value)}>
                                                        <option value="">Select Gender</option>
                                                        <option value="Male">Male</option>
                                                        <option value="Female">Female</option>
                                                    </select>
                                                    <span>Gender <i className='text-danger'>*</i></span>
                                                </label>
                                            </div>
                                            {errors.gender && <span className='badge text-danger span-error'>{errors.gender}</span>}
                                        </div>

                                        <div className="col-md-6 px-4">
                                            <div className="input-field">
                                                <label htmlFor="phone" className='label'>
                                                    <input type="text" id="phone" placeholder="Phone Number"
                                                        value={phone}
                                                        maxLength={10}
                                                        onChange={(e) => setPhone(e.target.value.replace(/\D/g, ''))}
                                                    />
                                                    <span>Phone Number <i className='text-danger'>*</i></span>
                                                </label>
                                            </div>
                                            {errors.phone && <span className='badge text-danger span-error'>{errors.phone}</span>}
                                        </div>

                                        <div className="col-md-6 px-4">
                                            <div className="input-field">
                                                <label htmlFor="email" className='label'>
                                                    <input type="text" id="email" placeholder="Email"
                                                        value={email}
                                                        onChange={(e) => setEmail(e.target.value.toLowerCase())}
                                                    />
                                                    <span>Email <i className='text-danger'>*</i></span>
                                                </label>
                                            </div>
                                            {errors.email && <span className='badge text-danger span-error'>{errors.email}</span>}
                                        </div>

                                        <div className="col-md-6 px-4">
                                            <div className="input-field position-relative">
                                                <label htmlFor="password" className='label'>
                                                    <input type={showPassword ? 'text' : 'password'} id="password"
                                                        value={password}
                                                        onChange={(e) => setPassword(e.target.value)}
                                                        placeholder="Leave blank to keep current password"
                                                        maxLength={15}
                                                    />
                                                    <span>New Password</span>
                                                </label>
                                                <div className="bd-eye-open" style={{ top: '38%' }}>
                                                    <a onClick={() => setShowPassword(!showPassword)} style={{ cursor: 'pointer' }}>
                                                        <i className={showPassword ? "icon-eye-crossed" : "icon-eye"}></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 text-center mt-5">
                                            <button type="button" onClick={() => navigate(-1)}
                                                className="button me-4"
                                                style={{ background: '#1a1a2e', color: '#fff', borderRadius: '12px' }}>
                                                <i className='icon-arrow-left me-2'></i>Back
                                            </button>
                                            <button type="submit" className="btn-green button" disabled={loading}>
                                                <i className={`bi bi-${loading ? 'arrow-repeat rotation me-3' : 'save'} me-2`}></i>
                                                Save
                                            </button>
                                        </div>

                                    </div>
                                </form>
                            </div>
                        </div>
                    </section>
                </div>
            </ContainerDashboard>
        </>
    )
}

export default EditStaff
